import VoyahTechnicalSpecsI18n from "../../Voyah/VoyahTechnicalSpecs/VoyahTechnicalSpecsI18n";
import tsImage from "../../../../assets/images/voyahfree/ts.png";

const VoyahFreeTechnicalSpecs = () => (
  <VoyahTechnicalSpecsI18n
    page="voyahfree"
    variant="free"
    i18nPrefix="voyahFree"
    tsImage={tsImage}
    highlightKeys={["1", "2", "3"]}
  />
);

export default VoyahFreeTechnicalSpecs;
